import React from 'react';
import PropTypes from 'prop-types';

function IconClose({ size = 16, color = `#808080`, className, style, onClick }) {
  return (
    <svg className={className} onClick={onClick} width={size} height={size} style={style} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4L4 12" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 4L12 12" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconClose.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func.isRequired,
}

export default IconClose;
